import type { IconProps } from "@/types/IconProps";

export function Instagram(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0M9.168 5.125a4.06 4.06 0 0 0-4.043 4.043v5.664a4.06 4.06 0 0 0 4.043 4.043h5.664a4.06 4.06 0 0 0 4.043-4.043V9.169a4.06 4.06 0 0 0-4.043-4.044zm5.664 1.25a2.79 2.79 0 0 1 2.793 2.793v5.664a2.79 2.79 0 0 1-2.793 2.793H9.169a2.79 2.79 0 0 1-2.582-1.724 2.8 2.8 0 0 1-.212-1.069V9.169a2.793 2.793 0 0 1 2.793-2.794zM12 8.25A3.76 3.76 0 0 0 8.25 12 3.76 3.76 0 0 0 12 15.75 3.76 3.76 0 0 0 15.75 12 3.76 3.76 0 0 0 12 8.25m0 1.25c1.39 0 2.5 1.11 2.5 2.5s-1.11 2.5-2.5 2.5-2.5-1.11-2.5-2.5 1.11-2.5 2.5-2.5m3.691-1.758a.565.565 0 0 0-.524.35.564.564 0 0 0 .524.783.565.565 0 0 0 .525-.349.6.6 0 0 0 .042-.217.56.56 0 0 0-.567-.567"></path>
    </svg>
  );
}
